var map = {
	"./default/favicons/android-chrome-192x192.png": 11105,
	"./default/favicons/android-chrome-512x512.png": 95889,
	"./default/favicons/apple-touch-icon.png": 70406,
	"./default/favicons/favicon-16x16.png": 42489,
	"./default/favicons/favicon-32x32.png": 72025,
	"./default/favicons/favicon.ico": 26026,
	"./default/icons/information.svg": 77526,
	"./default/icons/muted.svg": 74561,
	"./default/icons/share.svg": 66069,
	"./default/icons/unmuted.svg": 3426,
	"./default/logoDesktop.svg": 76028,
	"./default/logoMobile.svg": 21970,
	"./default/unmute.mp3": 94055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60951;